import { BALANCE } from '../config/balance';
import type { PlayerStats } from '../core/types';
import {
  placeBoomerangs, syncBoomerangs, type Boomerang,
} from './boomerang';
import type { WeaponController } from './weapon-controller';
import type { Engine } from './engine';

export interface BoomerangParams {
  count: number;
  damage: number;
  radius: number;
  angularSpeed: number;
  size: number;
  hitCd: number;
  knockback: number;
}

/** 回旋镖（绕身）：等级提供数量 / 伤害 / 轨道；进化多重回旋。 */
export class BoomerangController implements WeaponController {
  readonly id = 'boomerang';
  owned = true;
  list: Boomerang[] = [];
  /** 本帧参数（碰撞模块读取）。 */
  cur: BoomerangParams;
  private level = 1;
  private isEvolved = false;
  private trailT = 0;

  constructor() {
    this.cur = this.compute({} as PlayerStats);
  }

  syncBuild(level: number, evolved: boolean): void {
    this.level = level;
    this.isEvolved = evolved;
  }

  private compute(stats: PlayerStats): BoomerangParams {
    const w = BALANCE.weapons.boomerang;
    const L = this.level;
    let count = 1 + w.addCount.filter((lv) => L >= lv).length;
    let damage = w.dmg * (1 + w.dmgPer * (L - 1));
    const radius = w.orbit * (1 + w.orbitPer * (L - 1)) * stats.areaMul;
    let angularSpeed =
      w.speed * (1 + w.speedPer * (L - 1)) * stats.attackSpeedMul;
    const size = w.size * (1 + w.sizePer * (L - 1)) * stats.areaMul;
    if (this.isEvolved) {
      const e = BALANCE.evolutions.multi_boomerang;
      count *= e.countMul;
      damage *= 1 + e.dmgBonus;
      angularSpeed *= 1 + e.speedBonus;
    }
    return {
      count, damage, radius, angularSpeed, size,
      hitCd: w.hitCd, knockback: w.knockback,
    };
  }

  update(engine: Engine, dt: number): void {
    const p = engine.player;
    this.cur = this.compute(p.stats);
    syncBoomerangs(this.list, this.cur.count);
    placeBoomerangs(this.list, {
      px: p.x, py: p.y,
      radius: this.cur.radius,
      angularSpeed: this.cur.angularSpeed,
      spinSpeed: BALANCE.weapons.boomerang.spin,
      dt,
    });
    this.trailT -= dt;
    if (this.trailT <= 0) {
      this.trailT = BALANCE.juice.trailEvery;
      for (const b of this.list) engine.fx.trail(b.x, b.y);
    }
  }
}
